export async function loadCourse(courseKey) {
  if (!courseKey) return null;

  try {
    const [exercisesMod, glossaryMod, metadataMod, sharedMod] = await Promise.all([
      import(`./courses/${courseKey}/exercises.js`),
      import(`./courses/${courseKey}/glossary.js`),
      import(`./courses/${courseKey}/metadata.js`),
      import(`./courses/${courseKey}/shared.js`),
    ]);

    return {
      exercises: exercisesMod.default ?? exercisesMod.EXERCISES ?? [],
      GlossaryPanel: glossaryMod.default ?? null, // <-- component
      metadata: metadataMod.default ?? metadataMod.METADATA ?? {},
      shared: sharedMod ?? {},
    };
  } catch (err) {
    console.warn(`[loadCourse] missing course "${courseKey}"`, err);
    return null;
  }
}
